import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isFastConfigurationEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('fastConfiguration'),
)

export default isFastConfigurationEnabledSelector
